import React, { useCallback } from "react";
import { ChakraProps } from "@chakra-ui/react";
import { AsyncSearchProvider } from "./AsyncSearchProvider";
import AsyncSelect from "./AsyncSelect";
import useGuis from "../../hooks/guis/useGuis";

interface SelectGuiProps extends ChakraProps {
  value: string;
  setValue: (value: string) => void;
}

const SelectGui: React.FC<SelectGuiProps> = ({ color, value, setValue, ...chakraProps }) => {
  const { isLoading, error, guis = [] } = useGuis();

  const handleSearch = useCallback(
    async (searchQuery?: string): Promise<[string, string][]> => {
      return guis
        .filter(({ displayName }) => displayName.toLowerCase().includes(searchQuery?.toLowerCase().trim() ?? ""))
        .sort(({ displayName: a }, { displayName: b }) => a.localeCompare(b))
        .map(({ guiName, displayName }) => [guiName, `${displayName} (${guiName})}`]);
    },
    [guis]
  );

  return (
    <AsyncSearchProvider onSearchAsync={handleSearch}>
      <AsyncSelect
        selectedValue={value}
        setSelectedValue={setValue}
        color={color}
        title={"GUI"}
        isLoading={isLoading}
        error={error}
        {...chakraProps}
      />
    </AsyncSearchProvider>
  );
};

export default SelectGui;
